import { gql } from "generated-graphql";

export const TASKS_QUERY = gql(`
    query Tasks($search: String, $page: Int, $pageSize: Int, $sort: [SortModel!]) {
      virtualEvents(search: $search, page: $page, pageSize: $pageSize, sort: $sort) {
        count
        items {
          id
          seriesId
          taskId
          frequency
          interval
          title
          facilities {
            id
            name
          }
          status
          taskStatus
          deadline
          assignee {
            ...AssigneePicker
          }
          tags {
            id
            name
          }
        }
      }
    }
  `);

export const TASKS_COUNT_QUERY = gql(`
  query TasksCount($search: String) {
    virtualEvents(search: $search, page: 0, pageSize: 0) {
      count
    }
  }
`);
export const TASK_CALENDAR_SUBSCRIPTION_URL_QUERY = gql(`
  query TaskCalendarSubscriptionUrl($tenantId: ID!) {
    taskCalendarSubscriptionUrl(tenantId: $tenantId)
  }
`);

export const GENERATE_TASK_CALENDAR_TOKEN_MUTATION = gql(`
  mutation GenerateTaskCalendarToken($tenantId: ID!) {
    generateTaskCalendarToken(tenantId: $tenantId)
  }
`);

export const REVOKE_TASK_CALENDAR_TOKEN_MUTATION = gql(`
  mutation RevokeTaskCalendarToken($tenantId: ID!) {
    revokeTaskCalendarToken(tenantId: $tenantId)
  }
`);
